document.addEventListener("DOMContentLoaded", () => {
  $(".footer-block--menu .footer-block__heading").click(function () {
    $(this).toggleClass("active");
    $(this).siblings(".footer-menu-list").slideToggle();
  });

  // 底部返回页面顶部按钮
  const $BackBtn = $("#back-top-button");
  const $HtmlBody = $("html,body");
  $BackBtn.hide();

  $(window).scroll(function () {
    if ($(window).scrollTop() > 500) {
      $BackBtn.fadeIn();
    } else {
      $BackBtn.fadeOut();
    }
  });

  $BackBtn.click(function () {
    $HtmlBody.animate({ scrollTop: 0 }, 1000);
  });
});
